import { LoadingSkeleton } from '@eventbrite/timed-entry';
import React from 'react';
import styles from './TimeSlotLoadingSkeleton.module.scss';

export const TimeSlotLoadingSkeleton = () => {
    return (
        <div className={styles.loadingContainer}>
            {Array.from({ length: 1 }).map((_, i) => (
                <div key={i} className={styles.loadingItem}>
                    <LoadingSkeleton key={i} />
                </div>
            ))}
        </div>
    );
};
